import { PageBuilderProvider as PageBuilderProviderPackage } from '@chipinside/pagebuilder'
import { PropsWithChildren } from 'react'

import { useFormBuilder } from '#/store/hooks/useFormBuilder'
import { PageBuilderComponents } from '#/store/providers/Pagebuilder/components'
import { PageBuilderFallback } from '#/store/providers/Pagebuilder/fallback'
import Colors from '#/styles/Colors'
import Palette from '#/styles/Palette'

// TODO: Alterar isso depois que definirmos uma estrutura para cores para o backend poder acessar
export const pageBuilderColors = {
  ...Colors,
  feedback: {
    ...Colors.feedback,
    discard: {
      backgroundColor: '#FFEBEE',
      color: '#D02E26',
    },
    health: {
      backgroundColor: Palette.yellow.health[100],
      color: Palette.yellow.health[700],
    },
    primary: {
      backgroundColor: 'white',
      color: Colors.primary,
    },
    production: {
      backgroundColor: Palette.blue.production[100],
      color: Palette.blue.production[700],
    },
    reproduction: Colors.reproduction.heat,
    weaning: {
      backgroundColor: Palette.pink.rearing[100],
      color: Palette.pink.rearing[700],
    },
  },
}

export function PageBuilderProvider({ children }: PropsWithChildren) {
  const { build, confirm } = useFormBuilder()

  return (
    <PageBuilderProviderPackage
      components={PageBuilderComponents}
      fallback={PageBuilderFallback}
      colors={pageBuilderColors}
      functions={{ build, confirm }}
    >
      {children}
    </PageBuilderProviderPackage>
  )
}
